import type { RootState } from 'state';
import FetchingStatus from 'constants/statuses/FetchingStatus';

function isFetchingInProgress(state: RootState): boolean {
  const { fetching } = state.flightRoutes.routes;

  return fetching === FetchingStatus.InProgress;
}

export default isFetchingInProgress;
